import { COLORS, FONTS } from '../../../../constants';

// eslint-disable-next-line no-unused-vars
const styles = theme => ({
  root: {
    display: 'inline-block',
    fontFamily: FONTS.PRIMARY,
    color: COLORS.GREY_DARK,
    '& a': {
      textDecoration: 'none',
      color: COLORS.GREEN,
    },
  },
});

export default styles;
